import { cmdGetStartData } from '../../general/cmdGetStartData';

export class GetStartDataHandler {
    public handle(): void {
        cmdGetStartData(false);
    }
}
